import Maninjau1 from '../Maninjau/Maninjau (1).webp'
import Maninjau2 from '../Maninjau/Maninjau (2).webp'
import Maninjau3 from '../Maninjau/Maninjau (3).webp'
import Maninjau4 from '../Maninjau/Maninjau (4).webp'
import Maninjau5 from '../Maninjau/Maninjau (5).webp'
import Maninjau6 from '../Maninjau/Maninjau (6).webp'
import Maninjau7 from '../Maninjau/Maninjau (7).webp'
import Maninjau8 from '../Maninjau/Maninjau (8).webp'
import Maninjau9 from '../Maninjau/Maninjau (9).webp'
import Maninjau10 from '../Maninjau/Maninjau (10).webp'
import Maninjau11 from '../Maninjau/Maninjau (11).webp'
import Maninjau12 from '../Maninjau/Maninjau (12).webp'
import Maninjau13 from '../Maninjau/Maninjau (13).webp'


const Maninjauimages =[
Maninjau1,Maninjau2,Maninjau3,Maninjau4,Maninjau5,Maninjau6,Maninjau7,Maninjau8,Maninjau9,Maninjau10,Maninjau11,Maninjau12,Maninjau13
]

export default Maninjauimages;